module.exports = __webpack_public_path__ + "img/Beispiel-Vorschaubild-Video_1.0ecbdbf2.jpg";